// extracted by mini-css-extract-plugin
export default {"wrapper":"kt","subscription":"lt","select_item":"mt","is_selected":"nt","otb":"ot","radio":"pt","first_row":"qt","prices":"rt","italic":"st","info_wrapper":"tt","first_month":"ut","separator":"vt","checkmark":"wt","bullets":"xt","bullet":"yt","checkmarkText":"zt","button":"At","discountBadge":"Bt"};
    if(module.hot) {
      // 1738064238229
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  